import React, { useState, ChangeEvent, FormEvent } from "react";
import { Link, useNavigate } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import { REACT_APP_API_BASE_URL } from "../../../environment";

type PasswordField = "password";

interface LoginResponse {
  token: string;
  optional_holiday_taken?: number;
  user: {
    id: number;
    name: string;
    email: string;
  };
}

const Login2: React.FC = () => {
  const routes = all_routes;
  const navigate = useNavigate();

  const [email, setEmail] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [checked, setChecked] = useState(false);

  const togglePasswordVisibility = (field: PasswordField) => {
    if (field === "password") {
      setShowPassword((prev) => !prev);
    }
  };

  const validateEmail = (email: string): boolean => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  const validatePassword = (password: string): boolean => {
    return password.length >= 6;
  };

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
  
    const rememberMe = (document.querySelector("#remember_me") as HTMLInputElement)?.checked ? 1 : 0;
  
    if (!validateEmail(email)) {
      setError("Please enter a valid email address.");
      return;
    }
  
    if (!validatePassword(password)) {
      setError("Password must be at least 6 characters long.");
      return;
    }
  
    setIsLoading(true);
    setError(null);
  
    try {
      const response = await fetch(`${REACT_APP_API_BASE_URL}/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, password, rememberMe }),
      });
  
const data: LoginResponse = await response.json();

if (!response.ok) {
  throw new Error((data as any).error || "Something went wrong");
}

const flag = Number(data.optional_holiday_taken ?? 0); // normalize to 0/1

// persist token
localStorage.setItem("token", data.token);

// persist user WITH the flag on it so Leave reads it consistently
const mergedUser = { ...data.user, optional_holiday_taken: flag };
localStorage.setItem("user", JSON.stringify(mergedUser));

navigate(routes.dashboard);

    } catch (err: any) {
      setError("Login failed: " + (err.message || "Unknown error"));
    } finally {
      setIsLoading(false);
    }
  };
  

  return (
    <div className="container-fuild">
      <div className="w-100 overflow-hidden position-relative flex-wrap d-block vh-100">
        <div className="row login-bg-right">
          <div className="col-lg-5">
            <div className="d-lg-flex align-items-center justify-content-center d-none flex-wrap vh-100 login-bg-left">
              <div>
                <ImageWithBasePath src="assets/img/bg/auth-page.svg" alt="Img" />
              </div>
            </div>
          </div>
          <div className="col-lg-7 col-md-12 col-sm-12">
            <div className="row justify-content-center align-items-center vh-100 overflow-auto">
              <div className="col-md-7 mx-auto d-flex flex-column justify-content-center align-items-center vh-100">
                <form onSubmit={handleSubmit} className="w-100">
                  <div className="d-flex flex-column align-items-center gap-3 p-4">
                    <div className="text-center">
                      <ImageWithBasePath src="assets/img/logo.png" className="img-fluid" alt="Logo" />
                    </div>
                    <div className="w-100">
                      <div className="text-center mb-3">
                        <h2 className="mb-2">Sign In</h2>
                        <p className="mb-0">Please enter your details to sign in</p>
                      </div>
                      {error && (
                        <div className="alert alert-danger text-center">{error}</div>
                      )}
                      <div className="mb-3">
                        <label className="form-label">Email Address</label>
                        <div className="input-group">
                          <input
                            type="email"
                            className="form-control border-end-0"
                            value={email}
                            onChange={(e: ChangeEvent<HTMLInputElement>) => setEmail(e.target.value)}
                            required
                          />
                          <span className="input-group-text border-start-0">
                            <i className="ti ti-mail" />
                          </span>
                        </div>
                      </div>
                      <div className="mb-3">
                        <label className="form-label">Password</label>
                        <div className="pass-group">
                          <input
                            type={showPassword ? "text" : "password"}
                            className="pass-input form-control"
                            value={password}
                            onChange={(e: ChangeEvent<HTMLInputElement>) => setPassword(e.target.value)}
                            required
                          />
                          <span
                            className={`ti toggle-passwords ${showPassword ? "ti-eye" : "ti-eye-off"}`}
                            onClick={() => togglePasswordVisibility("password")}
                            style={{ cursor: "pointer" }}
                          ></span>
                        </div>
                      </div>
                      <div className="d-flex align-items-center justify-content-between mb-3">
                        <div className="d-flex align-items-center">
                          <div className="form-check form-check-md mb-0">
                            <input
                              className="form-check-input"
                              id="remember_me"
                              type="checkbox"
                              checked={checked}
                              onChange={() => setChecked(!checked)}
                            />
                            <label htmlFor="remember_me" className="form-check-label mt-0">
                              Remember Me
                            </label>
                          </div>
                        </div>
                        <div className="text-end">
                          <Link to={all_routes.forgotPassword} className="link-forgot">
                            Forgot Password?
                          </Link>
                        </div>
                      </div>
                      <div className="mb-3">
                      <button
                        type="submit"
                        className="btn btn-pink"
                        disabled={isLoading}
                      >
                        {isLoading ? "Signing in..." : "Sign In"}
                      </button>
                      </div>
                    </div>
                    {/* <div className="mt-5 pb-4 text-center">
                      <p className="mb-0 text-gray-9">© 2025 - Log Binary</p>
                    </div> */}
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login2;